<template>
  <div
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <div class="seasidetms_row_margin seasidetms_11">
            <div
              id="seasidetms_column_hir3kgnnpf"
              class="seasidetms_column one_first"
            >
              <div
                class="seasidetms_column_inner slider"
                id="seasidetms_heading_i8j83oo6mg"
              >
                <div class="h3 seasidetms_heading" v-if="title">
                  {{ title }}
                </div>
                <div
                  class="seasidetms_posts_slider seasidetms_posts_slider_product"
                >
                  <carousel
                    :nav="false"
                    :items="size"
                    :autoplay="true"
                    :responsive="{
                      0: { items: 2, nav: true },
                      1024: { items: size, nav: false },
                    }"
                  >
                    <div
                      v-for="(product, i) in products"
                      :key="`slide${i}`"
                      class="slide"
                    >
                      <div class="seasidetms_owl_slider_item">
                        <article
                          id="post-21490"
                          class="seasidetms_slider_product seasidetms_product post-21490 product type-product status-publish has-post-thumbnail product_cat-iphone-11 product_cat-used-iphone product_cat-iphone pa_color-yellow pa_dual-sim-no pa_memory-128gb pa_new-or-used-used last instock shipping-taxable purchasable product-type-simple"
                        >
                          <div class="seasidetms_product_wrapper_border">
                            <figure class="seasidetms_product_img preloader">
                              <div
                                class="seasidetms_product_sale_wrap"
                                v-if="product.bage"
                              >
                                <div class="seasidetms_product_sale_wrap">
                                  <span class="onsale">
                                    {{ $t(`bage.${product.bage}`) }}
                                  </span>
                                </div>
                              </div>
                              <a
                                href="#"
                                @click.stop.prevent="onDetails(product)"
                                class="ico-details icon-quick icon-search"
                                >&nbsp;</a
                              >
                              <router-link
                                :to="
                                  lang
                                    ? '/' +
                                      lang +
                                      '/product/' +
                                      categoryPath(product) +
                                      '/' +
                                      product.slug
                                    : '/product/' +
                                      categoryPath(product) +
                                      '/' +
                                      product.slug
                                "
                                :class="{
                                  payParts: Array.isArray(product.filters)
                                    ? product.filters[0].model
                                    : false,
                                }"
                                @click.native="onClickProdcut(product, i)"
                              >
                                <img
                                  :width="productImgWidth(product)"
                                  :height="productImgHeight(product)"
                                  class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail lazyloaded"
                                  :src="productImg(product)"
                                  :title="productName(product)"
                                  :alt="$h.getAlt(productName(product))"
                                />
                                <!--                                :sizes="productImgSizes(product)"-->
                                <!--                                :srcset="productImgSrcSet(product)"-->
                              </router-link>
                              <div class="seasidetms_product_sale_wrap"></div>
                            </figure>
                            <div class="seasidetms_product_inner">
                              <header
                                class="seasidetms_product_header entry-header"
                              >
                                <div
                                  class="h3 seasidetms_product_title entry-title"
                                >
                                  <router-link
                                    :to="
                                      lang
                                        ? '/' +
                                          lang +
                                          '/product/' +
                                          categoryPath(product) +
                                          '/' +
                                          product.slug
                                        : '/product/' +
                                          categoryPath(product) +
                                          '/' +
                                          product.slug
                                    "
                                    @click.native="onClickProdcut(product, i)"
                                  >
                                    {{ productName(product) }}
                                  </router-link>
                                </div>
                              </header>
                              <div class="seasidetms_product_info_wrap">
                                <div class="seasidetms_product_info">
                                  <span
                                    class="price price-usd-catalog"
                                    v-if="product.newPrice"
                                  >
                                    <span
                                      class="woocommerce-Price-amount amount"
                                    >
                                      <s> ₴{{ product.price }} </s>
                                    </span>
                                    <span
                                      style="
                                        margin-left: 50px;
                                        color: rgba(255, 67, 0, 0.9);
                                      "
                                      class="price-ukr"
                                    >
                                      ₴<span
                                        v-html="
                                          $h.formatPrice(product.newPrice)
                                        "
                                      ></span>
                                    </span>
                                  </span>
                                  <span
                                    class="price"
                                    style="justify-content: center !important"
                                    v-else
                                  >
                                    <span
                                      class="woocommerce-Price-amount amount"
                                    >
                                    </span>
                                    <span class="price-ukr">
                                      <span
                                        v-html="$h.formatPrice(product.price)"
                                      ></span
                                      >грн
                                    </span>
                                  </span>
                                </div>
                                <rating :rating="product.rating" />
                                <div class="seasidetms_product_add_wrap">
                                  <div class="seasidetms_product_add_inner">
                                    <a
                                      href="#"
                                      id="add-to-cart-button"
                                      class="seasidetms_product_button add_to_cart_button seasidetms_add_to_cart_button product_type_simple ajax_add_to_cart"
                                      :title="$t('toCart')"
                                      @click.stop.prevent="
                                        onAddToCart(product, i)
                                      "
                                      v-if="product.stock && !inCart(product)"
                                    >
                                      <span>
                                        {{ $t('toCart') }}
                                      </span>
                                    </a>
                                    <router-link
                                      id="add-to-cart-button"
                                      :to="
                                        lang ? '/' + lang + '/cart' : '/cart'
                                      "
                                      class="seasidetms_product_button wc-forward"
                                      :title="$t('showCart')"
                                      v-if="product.stock && inCart(product)"
                                    >
                                      <span>
                                        {{ $t('showCart') }}
                                      </span>
                                    </router-link>
                                    <a
                                      href="#"
                                      class="seasidetms_product_button"
                                      @click.stop.prevent="
                                        onNotifyOnStock(product)
                                      "
                                      v-if="!product.stock"
                                    >
                                      {{ $t('notifyOnStock') }}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </article>
                      </div>
                    </div>
                  </carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import carousel from 'vue-owl-carousel'
import { mapActions, mapState } from 'vuex'
import Rating from '@/components/Rating'

export default {
  name: 'ProductsSlider',
  components: { carousel, Rating },
  props: {
    products: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    size: {
      type: Number,
      required: false,
      default: 4,
    },
  },
  computed: {
    ...mapState(['cart']),
  },
  methods: {
    productImg(product) {
      return Array.isArray(product.img) && product.img.length
        ? `/img${product.img[0]}`
        : product.img
        ? `/img${product.img}`
        : '/img/uploads/error.png'
    },
    productName(product) {
      return product[`name_${this.$i18n.locale}`]
        ? product[`name_${this.$i18n.locale}`]
        : product.name
        ? product.name
        : ''
    },
    inCart(product) {
      return !!this.cart.items.find((item) => item.id === product._id)
    },
    onDetails(product) {
      this.$store.commit('setProductInfoModal', product)
    },
    onAddToCart(product, i) {
      let item = {}
      Object.assign(item, product, { single: true })
      let variant = ''
      let p = product
      if (p['filters']) {
        if (p['filters'][0]['color']) {
          variant = p['filters'][0]['color']
        }
        if (variant && p['filters'][0]['memory']) {
          variant = variant + ' ' + p['filters'][0]['memory']
        }
      }
      let listcat_full = this.categoryName(product)

      this.$h.gtmDataLayerPush({
        ecomm_pagetype: 'cart',
        ecomm_prodid: p['id'],
        ecomm_totalvalue: p['newPrice'] ? p['newPrice'] : p['price'],
      })
      const item_list_id = uuidv4()
      this.$gtag.event('add_to_cart', {
        items: [
          {
            item_name: p[`name_${this.$i18n.locale}`],
            item_id: p['id'],
            price: p['newPrice'] ? p['newPrice'] : p['price'],
            currency: 'UAH',
            item_brand: 'Apple',
            item_category: listcat_full,
            item_list_name: 'Slider product',
            item_list_id,
            index: i || 0,
            quantity: 1,
          },
        ],
      })
      this.addToCart(item)
    },
    onNotifyOnStock() {
      this.$store.commit('setNotifyStockModal', true)
    },
    onClickProdcut(product) {
      //console.log('--->>here home')
      //console.log(product)
      let variant = ''
      let p = product
      if (p['filters']) {
        if (p['filters'][0]['color']) {
          variant = p['filters'][0]['color']
        }
        if (variant && p['filters'][0]['memory']) {
          variant = variant + ' ' + p['filters'][0]['memory']
        }
      }
      let listcat_full = this.categoryName(product)

      this.$gtag.event('select_content', {
        content_type: 'product',
        items: [
          {
            id: p['_id'],
            name: p[`name_${this.$i18n.locale}`],
            list_name: 'Slider product',
            brand: 'Apple',
            category: listcat_full,
            variant: variant,
            price: p['newPrice'] ? p['newPrice'] : p['price'],
          },
        ],
      })
      return true
    },
    categoryName(product) {
      const cc = `${product.childCategory}`
      let refPath = `${product.parentCategory}/${cc.replace(',', '/')}`
      let path = ''
      let chain = refPath.split('/')
      let _c = this.$store.state.categories
      chain.forEach((p) => {
        if (!_c) return
        let c = _c.find((c) => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c[`name_${this.$i18n.locale}`]
        }
      })
      return path
    },
    categoryPath(product) {
      const _this = this
      // return path to related category, by search in category tree by parentCategory and childCategory
      const cc = `${product.childCategory}`
      let refPath = `${product.parentCategory}/${cc.replace(',', '/')}`
      if (this.$cachedCategoryPaths[refPath]) {
        return this.$cachedCategoryPaths[refPath]
      }
      let path = ''
      let chain = refPath.split('/')
      let _c = this.$store.state.categories
      chain.forEach((p) => {
        if (!_c) return
        let c = _c.find((c) => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c.slug
        }
      })
      _this.$cachedCategoryPaths[refPath] = path
      return path
    },
    productImgSrcSet(product) {
      // extract missing w from filenames
      return product.srcset
        ? product.srcset
            .map((v) => {
              let m = v.match(/(\d+)x\d+\.(png|jpg|jpeg|gif)$/i)
              if (m && m.length > 1) {
                return `/img${v} ${m[1]}w`
              } else {
                return `/img${v} 75w`
              }
            })
            .join(',')
        : ''
    },
    productImgSrc(product) {
      return Array.isArray(product.img) && product.img.length
        ? `/img${product.img[0]}`
        : product.img
        ? `/img${product.img}`
        : '/img/uploads/error.png'
    },
    productImgSizes() {
      return this.productImgSrcSet ? '(max-width: 540px) 100vw, 540px' : ''
    },
    productImgWidth(product) {
      if (product.srcset.find((v) => v.match('540x540'))) {
        return 540
      }
      return 410
    },
    productImgHeight(product) {
      if (product.srcset.find((v) => v.match('580x410'))) {
        return 410
      }
      return 415
    },
    ...mapActions(['addToCart']),
  },
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
/* .slider { */
/*padding-top: 30px;*/
/* } */
.slider .owl-carousel {
  margin-top: 48px;
}

.owl-carousel .owl-item img {
  padding-top: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
/* .slider .owl-stage-outer,
.slider .owl-stage { */
/*min-height: 200px;
  max-height: 200px;*/
/* } */
/* .slider .owl-item { */
/*min-width: 250px;
  min-height: 200px;*/
/* } */
.product .preloader img {
  height: auto !important;
}
.slider .owl-dots {
  position: absolute;
  right: 20px;
  top: -38px;
}
@media only screen and (max-width: 1024px) {
  .slider .owl-carousel {
    margin-top: 0;
  }
  .price-size {
    font-size: 16px !important;
  }
}
@media only screen and (min-width: 1024px) {
  .slider .h3.seasidetms_heading {
    position: absolute;
  }
}
</style>
